import { ethers } from 'ethers';
import { isProviderResponding } from './utils';

// Browser wallets estimate gas and broadcast transactions through their own configured RPC URL,
// which the dApp cannot override. Check that it responds (liveness only, since the connected chain
// is enforced by the switch-network modal) so a broken wallet RPC fails with an actionable message.
export const isWalletRpcResponding = async (signer: ethers.Signer) => {
  const { provider } = signer;
  if (!provider) return false;

  // Test mode signers are connected to a FallbackProvider, which doesn't support raw RPC calls and
  // doesn't represent a wallet RPC, so skip the check for them
  if (!(provider instanceof ethers.JsonRpcApiProvider)) return true;

  return isProviderResponding(provider);
};
